<template lang="pug">
  #list_table.frequency-list.scroller(
    v-shortkey="['arrowright']"
    @shortkey="nextPage()"
  )
    div(
    v-shortkey="['arrowleft']"
    @shortkey="previousPage()"
    )
      b-table.w-100(
        striped
        ref="table"
        :current-page.sync="currentPage"
        :paginated="true"
        :per-page="10"
        :loading="queryingWords"
        :pagination-simple="false"
        :opened-detailed="defaultOpenedDetails"
        detailed
        detail-key="rank"
        :data="sortedData"
        :show-detail-icon="false"
        )
        template(slot="bottom-left" slot-scope="props")
          b-input.is-narrow.ml-2(
            v-model="forceCurrentPage"
            type="number"
            min="0"
            :max="sortedData.length"
          )

          span.show-matches.ml-2(v-if="initialLength !== sortedData.length" :disabled="true")
            | {{ sortedData.length }} match{{ sortedData.length > 1 ? 'es' : '' }}
        template(slot-scope="props")

          // RANK
          b-table-column.c--rank(field="rank" label="Rank" sortable width="40" numeric)
            | {{ props.row.rank }}

          // LEMMA
          b-table-column.c--lemma(field="lemma" label="Lemma" sortable)
            h3.title.is-clickable.has-text-dark.is-flex(@click="speak(props.row.lemma, $event)" :data-uid="props.row.lemma+props.row.pos")
              span
                | {{ props.row.lemma }}
              .ml-auto
                button.share.button.is-primary.is-inverted.is-small.mr-2(
                  @click="share(props.row)"
                  )
                  b-icon(icon="link")

          // POS
          b-table-column.c--pos(field="pos" label="Part of Speech" width="150" sortable)
            | {{ pos[props.row.pos] }}

          // INFLECTIONS
          b-table-column.c--inf(label="Inflections")

            button.button.is-small.mr-2.button-play(
              @click='speak(Object.keys(props.row.inf).join(`, `), $event);toggle(props.row)'
              )
              b-icon(icon="play-arrow" custom-size="mdi-18px")
            b-dropdown.is-narrow.intonation-display(
              v-for="(ha, inflection) of props.row.inf"
              :key="inflection"
              :position="isMobile ? 'is-top-left' : 'is-top-right'"
              paddingless
              :hoverable="true"
              :class=`{
                    'is-small': Object.keys(props.row.inf).length > 4
                    }`
              )
              button.button.is-outlined.mr-2.button-tts(
              slot="trigger"
              :class=`{
                  'is-small': Object.keys(props.row.inf).length > 4,
                  'is-primary': !phonemes.length || (ha.ipa && ha.ipa.match(phonemesRegex)),
                  'is-warning': (phonemes.length && (!ha.ipa || !ha.ipa.match(phonemesRegex))) || (stressPatterns.length && (!ha.i || !ha.i.match(stressPatternsRegex))) || (syllables.length && (!ha.i || syllables.indexOf(ha.i.split('|')[0].length+'') === -1))
                }`
              :data-ipa="ha.ipa"
              @mousedown="speak(inflection, $event)")
                | {{ inflection }}
              b-dropdown-item.button.is-white(
              v-for="(int, idx) in uniq((ha.i || '').split('|'))"
              v-if="int.length > 1"
              :key="idx"
              :class=`{
                  'is-small': Object.keys(props.row.inf).length > 4,
                  'is-warning': (phonemes.length && (!ha.ipa || !ha.ipa.match(phonemesRegex))) || (stressPatterns.length && (!ha.i || !ha.i.match(stressPatternsRegex)))
                  }`
              )
                span(v-for="nb in int.split('')" :class="['is-int-'+nb]")
                  | ●

          // VIDEO
          b-table-column.c--vid(field="created_at" label="Video" width="50")
            button.button.ml-auto.mr-1.is-small.button-video.is-white(
            v-if="sentences[props.row.lemma] || sentences[props.row.lemma+'|'+props.row.pos]"
            @click="toggle(props.row)"
            )
              img(width="27" height="27" src="/static/youtube-play-active.png")
              <!--b-icon(icon="videocam" custom-size="mdi-18px")-->
            b-tooltip.ml-auto.mr-1(
            v-else
            :label='`Add a Youtube video for: "${props.row.lemma}"`'
            type='is-primary'
            :animated='true'
            position='is-left'
            )
              button.button.is-outlined.is-small(
              @click="openYoutubeModal(props.row)"
              )
                <!--:title="(!user.id) ? 'Please log in to add videos' : ''"-->
                b-icon(icon="video-call" custom-size="mdi-18px")

        template(slot="detail" slot-scope="props")
          sentences(:current-word="props.row")

      b-modal#share_modal(:active.sync="shareModal" :width="620")
        .box
          .content.has-text-left
            h3 Copy/paste to share
            b-field.is-fullwidth.is-light
              .control.is-clearfix
                input.input(:value="url" ref="shareUrl" @keyup="url = forceUrl")

</template>

<script>
  // <div>Icons made by <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">Smashicons</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></div>

  // https://github.com/tangbc/vue-virtual-scroll-list

  // const data = require('@/data/words.json');
  // const data = [];
  const arpabet = require('@/data/arpabet.json');
  import sentences from "@/components/Sentences";
  import Audio from '@/services/Audio.js.coffee'
  import { nodeApi } from "@/config";
  import _ from "lodash";
  import youtubeModal from '@/components/YoutubeModal';
  import {mapGetters, mapActions} from 'vuex'


  export default {
    name: "ListV2",
    components: {
      sentences,
    },
    computed: {
      ...mapGetters(['voices', 'display', 'filters', 'sentences', 'user']),
      uniqData() {
       return _.filter(this.data, (word) => word.rank);
      },
      syllables() {
        return _.keys(_.pickBy(this.filters.syllables));
      },
      search() {
        return this.filters.search
      },
      searchRegex: function () {
        if (!this.filters.search || !this.filters.search.length) {
          return null;
        }

        let regex = this.filters.search
        if (!this.filters.options.searchIsRegex) {
          if (this.filters.options.searchStartsWith) {
            regex = `(?:^|\\|)${regex}`
          }
          if (this.filters.options.searchEndsWith) {
            regex += `(?:$|\\|)`
          }
        }
        return RegExp(regex, 'i');
      },
      stressPatterns() {
        return _.keys(_.pickBy(this.filters.stressPatterns));
      },
      stressPatternsRegex() {
        return RegExp(`(?:^|\\|)(${this.stressPatterns.join('|')})(?:$|\\|)`);
      },
      phonemes() {
        return _.keys(_.pickBy(this.filters.phonemes));
      },
      phonemesRegex() {
        return RegExp(`(${this.phonemes.join('|').replace(/[ʳ::]/g, '')})`);
      },
      filteredData() {
        const availableFilteredAttrs = ['pos', 'lemma'];
        const availableOtherFilters = ['phonemes', 'stressPatterns', 'syllables', 'videos'];
        const filteredAttr = [];
        const otherFilters = [];
        let dataBeingFiltered = []

        for (const fil of availableFilteredAttrs) {
          if (_.some(_.values(this.filters[fil]), (val) => val)) {
            filteredAttr.push(fil);
          }
        }
        for (const fil of availableOtherFilters) {
          if (_.some(_.values(this.filters[fil]), (val) => val)) {
            otherFilters.push(fil);
          }
        }
        if (this.searchRegex) {
          otherFilters.push('search');
        }

        if (filteredAttr.length || otherFilters.length || this.filters.options.withVideoOnly) {
          dataBeingFiltered = this.uniqData;


          for (const fil of filteredAttr) {
            const vals = _.keys(_.pickBy(this.filters[fil]));
            console.log('We are filtering on: ', fil, ' with vals: ', vals);
            dataBeingFiltered = _.filter(dataBeingFiltered, word => _.includes(vals, word[fil]));
          }
          if (otherFilters.indexOf('videos') !== -1) {
            const videos = _.keys(_.pickBy(this.filters.videos));
            const withoutVideo = videos.indexOf('without') !== -1;
            console.log('We are filtering on: videos with vals: ', videos);
            dataBeingFiltered = _.filter(dataBeingFiltered, word => {
              const toFilter = this.sentences[word.lemma] || this.sentences[word.lemma+'|'+word.pos];
              if (toFilter) {
                for (let sentence of toFilter) {
                  if ( _.includes(videos, sentence.category) ) {
                    return true
                  }
                }
              } else if (withoutVideo) {
                return true
              } else {
                return false
              }
            });
          }
          if (otherFilters.indexOf('phonemes') !== -1) {
            dataBeingFiltered = _.filter(dataBeingFiltered, (word) => {
              if (!word.inf) {
                return false;
              }

              for (const inf in word.inf) {
                if (word.inf[inf].ipa && word.inf[inf].ipa.match(this.phonemesRegex)) {
                  return true
                }
              }
              return false;
            });
          }
          if (otherFilters.indexOf('stressPatterns') !== -1) {
            dataBeingFiltered = _.filter(dataBeingFiltered, (word) => {
              if (!word.inf) {
                return false;
              }

              for (const inf in word.inf) {
                if (word.inf[inf].i && word.inf[inf].i.match(this.stressPatternsRegex)) {
                  return true
                }
              }
              return false;
            });
          }

          if (otherFilters.indexOf('syllables') !== -1) {
            dataBeingFiltered = _.filter(dataBeingFiltered, (word) => {
              if (!word.inf) {
                return false;
              }

              for (const inf in word.inf) {
                if (word.inf[inf].i && this.syllables.indexOf(word.inf[inf].i.split('|')[0].length+'') !== -1) {
                  return true
                }
              }
              return false;
            });
          }

          if (otherFilters.indexOf('search') !== -1) {
            dataBeingFiltered = _.filter(dataBeingFiltered, (word) => {
              if (word.lemma && word.lemma.match(this.searchRegex)) {
                return true
              }

              if (!word.inf) {
                return false;
              }

              for (const inf in word.inf) {
                if (inf.match(this.searchRegex)) {
                  return true
                }
              }
              return false;
            });
          }

          return dataBeingFiltered
        } else {
          return this.uniqData;
        }
      },
      sortedData() {
        if (this.sortBy == null) {
          return this.filteredData
        } else {
          return _.sortBy(this.filteredData, [this.sortBy])
        }
      }
    },
    watch: {
      forceCurrentPage(newVal) {
        this.currentPage = parseInt(newVal);
      },
      currentPage: _.debounce(function()  {
        if (this.forceCurrentPage !== this.currentPage) {
          this.forceCurrentPage = this.currentPage;
        }
      }, 200),
      search() {
        this.currentPage = 1;
      }
    },
    data() {
      return {
        forceCurrentPage: 1,
        url: '',
        forceUrl: '',
        shareModal: false,
        defaultOpenedDetails: [],
        isMobile: false,
        currentPage: 1,
        hasToFetch: true,
        queryingWords: true,
        arpabet: _.keyBy(arpabet, 'arpabet'),
        currentWord: {},
        audio: null,
        uniq: _.uniq,
        data: [],
        initialLength: 0,
        pos: {
          v: 'verb',
          fw: 'function word',
          u: 'interjection',
          r: 'adverb',
          j: 'adjective',
          m: 'number',
          n: 'noun',
          K: 'proper noun',
          abbr: 'abbreviation',
        },
        sortBy: null,
        loading: false,
        lineColors: [
          '#83ABEC',
          '#BC1605'
        ],
        colors: [
          '#83ABEC',
          '#f1c40f',
          '#F1240F',
          '#BC1605'
        ]
      };
    },
    mounted () {
      this.audio = Audio.init();




    },
    created() {
      this.$store.dispatch('getSentences');
      if (this.user.id) {
        this.$store.dispatch('getVotes');
      }
      this.getWords().then(body => {
      // this.$http.get('/static/data/words.json').then(res => {
        this.data = body;
        this.queryingWords = false;
        this.hasToFetch = false;
        this.callbackWhenDataExists();
      })
      this.isMobile = this.detectIfMobile();
    },
    methods: {
      ...mapActions(['getWords']),
      focusOnWord(lemma, pos) {
        const idx = _.findIndex(this.sortedData, { lemma, pos })
        this.forceCurrentPage = this.currentPage = Math.floor((idx)/10)+1;

        setTimeout(() => {
          console.log({idx, page: Math.floor((idx)/10)+1, query: `[data-uid='${lemma}${pos}']`});
          const dom = document.querySelector(`[data-uid='${lemma}${pos}']`)
          if (dom) {
            window.scroll(0, dom.getBoundingClientRect().top-15);
            console.log({dom});
          }
        }, 300);

      },
      share(word) {
        this.url = `${window.location.origin}/w/${word.lemma}/${word.pos}`;
        this.forceUrl = this.url;

        this.shareModal = true;
        setTimeout(() => {
          this.$refs.shareUrl.focus();
          this.$refs.shareUrl.select();
        }, 300);
      },
      toggle(row) {
        if (this.sentences[row.lemma] || this.sentences[row.lemma+'|'+row.pos]) {
          this.$store.commit('currentWord', row);
          // this.defaultOpenedDetails = [];
          this.$refs.table.toggleDetails(row);
        }
      },
      previousPage() {
        document.querySelector('#list_table .pagination-previous').click()
      },
      nextPage() {
        document.querySelector('#list_table .pagination-next').click()
      },
      detectIfMobile() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) || (navigator.userAgent.indexOf('iPhone') !== -1);
      },
      callbackWhenDataExists() {
        let missingCount = 0;
        for (const word in this.data) {
          if (!this.data[word].a) {
            // console.log(this.data[word].lemma, 'has no arpabet');
            missingCount++;
            continue;
          }

          this.$set(this.data[word], 'ipa', this.data[word].a.replace(/\d/g, '').split('|')[0].split(' ').map(sym => (this.arpabet[sym] || {}).ipa).join(''))
          for (const infl in this.data[word].inf) {
            if (!this.data[word].inf[infl].a) {
              // console.log('Inflection : ', infl, 'has no arpabet');
              missingCount++;
              continue;
            }

            this.$set(this.data[word].inf[infl], 'ipa', this.data[word].inf[infl].a.replace(/\d/g, '').split('|')[0].split(' ').map(sym => (this.arpabet[sym] || {}).ipa).join(''))
          }
        }
        console.log(missingCount, ' are missing arpabet');
        this.initialLength = this.uniqData.length;
        setTimeout(function() {
          document.dispatchEvent(new Event('x-app-rendered'));
        }, 1000);



        const { word, pos } = this.$route.params;
        if (word) {
          setTimeout(() => {
            this.focusOnWord(word, pos);
          }, 300);
        }

        if (this.$route.query && this.$route.query.page) {
          this.forceCurrentPage = this.currentPage = parseInt(this.$route.query.page);
        }
      },
      scrollToSentences() {
        setTimeout(() => {
          const sentencesDom = document.getElementById('sentences');
          window.scrollTo(0, sentencesDom.offsetTop);
        }, 200);
      },
      intToNbs(stressPatterns) {
        let nbs = [0, 0];
        nbs = nbs.concat(_.map(stressPatterns.split(''), (item) => (parseInt(item)+1)*30))
        nbs.push(0);
        nbs.push(0);
        return nbs
      },
      // lineColors(stressPatterns) {
      //   // const colors = [this.colors[0], this.colors[0]];
      //   // _.each(stressPatterns.split(''), (nb) => {
      //   //   colors.push(this.colors[parseInt(nb)])
      //   // })
      //   // colors.push(this.colors[0])
      //   // colors.push(this.colors[0])
      //   // return colors
      //
      //   return  ['#83ABEC',
      //     // '#f1c40f',
      //     // '#F1240F',
      //     '#BC1605']
      // },
      openYoutubeModal({lemma, pos}) {
        this.$modal.open({
          parent: this,
          width: 1440,
          props: {
            lemma,
            pos
          },
          component: youtubeModal,
          hasModalCard: false
        })
      },
      toggleFilter() {
        this.$store.commit('editDisplay', {...this.display, filters: !this.display.filters})
      },
      speak: function(text, event) {
        if (text.length == 1)
          text = text.toLowerCase()
        this.audio.speak(text,  event, 'en-US', this.voices['en-US']);
        // this.$mixpanel.track("Listen to word");
      }
    }
  };
</script>

<style lang="scss">
  @import "colors";

  .scroller {
    /*overflow: hidden;*/
    /*height: 56vh;*/
    /*max-height: 674px;*/
    width: 100%;
  };
  .frequency-list {
    display: block;
    background: #FFF;
    h3.title {
      font-weight: 700;
      font-size: 1.6rem;
    }
    .show-matches,
    .button-toggle-filters {
      position: relative;
    }
    .table td {
      min-height: 66px;
      height: 66px;
      vertical-align: middle;
    }
    .show-matches {
      background-color: transparent;
      -webkit-box-shadow: none;
      box-shadow: none;
      border-radius: 30px;
      padding: 0.1em 1em;
      display: inline-flex;
      vertical-align: middle;
      color: $success;
      border: 1px solid $success;
    }
    &.has-to-fetch {
      .c--inf {
        button.button-tts {
          display: none
        }
      }
    }


    li.th.c--id {
      text-align: left;
    }
    .c--id { min-width: 60px }
    .c--rank { min-width: 100px }
    .c--lemma { min-width: 160px }
    .c--pos { min-width: 160px }
    .c--inf { flex-grow: 1; }
    .c--vid { min-width: 60px; text-align: right }

    .tabs a {
      border-bottom-width: 2px;
      height: 37px;
    }

    .intonation-display {
      isplay: inline-flex;
      align-items: center;
      span {
        vertical-align: middle;
        display: inline-block;
        line-height: 30px;
        width: 19px;
        height: 30px;
        text-align: center;

      }
      .is-int-0 { font-size: 0.5rem; }
      .is-int-1 { font-size: 1.2rem; }
      .is-int-2 { font-size: 1.9rem; width: 25px; line-height: 27px; }
      .dropdown-item {
        pointer-events: none;
        border-radius: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        /*min-width: 36px;*/
        min-width: 116px;
        min-height: 36px;
        padding: 0 1em;

        svg {
          height: 100% !important
        }

        &.is-small {
          min-height: 22px;
        }
      }

    }

    .button-video {
      padding: 0;
      img {
        width: auto;
        height: 27px;
      }
    }

    .pagination {
      margin-right: 0.5rem !important;
    }
    .pagination-link.is-current {
      color: #fff !important;
    }

    .dropdown .dropdown-menu {
      bottom: 157% !important;
      min-width: 0;
    }
    .dropdown-content {
      display: flex;
      padding-bottom: 0.2rem;
      padding-top: 0.2rem;
      a.dropdown-item+a.dropdown-item {
        border-left: 1px solid #ececec;
      }
    }


    .has-loader.is-loading {
      margin-top: 140px;
    }

    .c--cmds button,
    .table .th {
      text-align: left;
      color: $gray;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 11px;
      a {
        justify-content: start;
      }
      &.is-active {
        color: $primary;
      }
    }

    button.share.button {
      opacity: 0;
      transform: translate3d(0,10px,0);
      transition: transform .3s ease-in-out,opacity .3s ease-in;
    }

    .button-tts {
      position: relative;
      transform: translate3d(0,0,0);
      transition: transform .3s ease-in-out,opacity .3s ease-in;
      &:after {
        transition: transform .3s ease-in-out,opacity .3s ease-in;
        transform: translate3d(0,0,0);
        opacity: .001;
        color: $primary;
        position: absolute;
        content: attr(data-ipa);
        top: 35px;
        width: 100%;
        font-size: 17px;
      }
      &.is-small:after {
        top: 28px;
      }

    }
    tr:hover {
      .button-tts:after {
        opacity: 1;
        transform: translate3d(0,0,0);
      }
      .button-tts {
        transform: translate3d(0,-10px,0);
      }

      button.share.button {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      .appears-on-hover {
        display: block;
      }
    }

    .sentences {
      padding-left: 166px !important;
      background-color: $primaryLight;
      text-align: left;
      color: $white;
    }

    .appears-on-hover {
      display: none;
      position: absolute;
      bottom: 0;
    }
  }

  // ANIMATIONS

  @-webkit-keyframes slideFromRight {
    0% {
      opacity: 0;
      transform: translateY(30px) scale(1.5);
    }
    100% {
      opacity: 1;
      transform: translateY(0px) scale(1);
    }
  }
  @keyframes slideFromRight {
    0% {
      opacity: 0;
      transform: translateY(30px) scale(1.3);
    }
    100% {
      opacity: 1;
      transform: translateY(0px) scale(1);
    }
  }

  /*@-webkit-keyframes buttonClicked {*/
    /*0% { -webkit-transform: scale(1); }*/
    /*20% { -webkit-transform: scale(0.8); }*/
    /*50% { -webkit-transform: scale(1.2); }*/
    /*100% { -webkit-transform: scale(1); }*/
  /*}*/

  /*@keyframes buttonClicked {*/
    /*0% { -webkit-transform: scale(1); }*/
    /*20% { -webkit-transform: scale(0.8); }*/
    /*50% { -webkit-transform: scale(1.1); }*/
    /*100% { -webkit-transform: scale(1); }*/
  /*}*/

  /*  MOBILE */

  @media screen and (max-width: 1068px) {
    .frequency-list .c--lemma { min-width: 120px; }
    .frequency-list .c--pos { min-width: 130px; }
    .frequency-list .c--rank { min-width: 90px; }
  }
  @media screen and (max-width: 768px) {
    body .frequency-list .table td {
      min-height: auto;
      height: auto;
    }
    body td.c--inf {
      min-height: 50px;
      height: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    body .frequency-list tr:hover {
      .intonation-display {
        height: 60px;
        align-items: flex-start;
      }
    }
    body .frequency-list .dropdown .dropdown-menu {
      bottom: 130% !important;
    }
    table.has-mobile-cards .button-tts {
      margin-right: 0 !important;
      margin-left: 0.5rem;
      margin-bottom: 0.5rem;
    }
    table.has-mobile-cards tr.detail {
      box-shadow: none;
    }
  }

</style>

</template>





// WEBPACK FOOTER //
// src/components/ListV2.vue